import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnCK: CultureInfo = {
  name: 'en-CK',
  displayName: 'English (Cook Islands)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-CK',
  parent: CultureInfoEn
};
